import { useQueryClient } from "@tanstack/react-query";
import { notification } from "antd";
import { useFormContext } from "react-hook-form";
import { useCoordinator } from "@/shared/lib/hooks";
import { NOTIFICATION_MESSAGES } from "@/shared/utils";
import { journalsQueries } from "@entities/journal";
import { $journalApi } from "@entities/journal/fetch/fetch-client.ts";

interface IUseRejectGSN {
  setIsLoading?: (value: boolean) => void;
  handleClear: () => void;
}

export const useRejectGSN = ({ setIsLoading, handleClear }: IUseRejectGSN) => {
  const { titleId } = useCoordinator();
  const queryClient = useQueryClient();
  const { getValues } = useFormContext();

  const mutation = $journalApi.useMutation(
    "post",
    "/api/v1/journals/title/{titleId}/status/reject/send",
  );

  const handleRejectGSN = async () => {
    const comment = getValues("comment");

    if (!comment) {
      notification.warning({
        message: NOTIFICATION_MESSAGES.TITLE_COMMENT_REQUIRED, // "Требуется комментарий"
        description: NOTIFICATION_MESSAGES.TITLE_REJECT_COMMENT_REQUIRED_DESC, // "Пожалуйста, укажите причину отклонения титульного листа."
        placement: "topRight",
      });
      return;
    }

    setIsLoading?.(true);

    mutation.mutate(
      {
        params: { path: { titleId } },
        // @ts-expect-error body не совпадает с openapi типами мутации
        body: { newStatus: "REJECTED", comment },
      },
      {
        onSuccess: () => {
          notification.success({
            message: NOTIFICATION_MESSAGES.SUCCESS, // "Успешно"
            description: NOTIFICATION_MESSAGES.TITLE_GSN_REJECTED_DESC, // "Титульный лист отклонён для ГСН"
            placement: "topRight",
          });
          queryClient.invalidateQueries({
            queryKey: journalsQueries.getTitleJournal({ titleId }).queryKey,
          });
          handleClear();
        },
        onError: () => {
          notification.error({
            message: NOTIFICATION_MESSAGES.ERROR, // "Ошибка"
            description: NOTIFICATION_MESSAGES.TITLE_REJECT_FAILED_DESC, // "Не удалось отклонить титульный лист"
            placement: "topRight",
          });
          handleClear();
        },
        onSettled: () => {
          setIsLoading?.(false);
        },
      },
    );
  };

  return { handleRejectGSN };
};

